import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Search, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { ClientCard } from "@/components/feature/media/client-card";
import { ClientFormDialog } from "@/components/feature/media/client-form-dialog";
import { media, type AgencyClientOut } from "@/lib/api";

export const Route = createFileRoute("/_auth/clients/")({
  component: ClientsList,
});

function ClientsList() {
  const [q, setQ] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editing, setEditing] = useState<AgencyClientOut | null>(null);

  const { data, isLoading } = useQuery({
    queryKey: ["media", "clients", q],
    queryFn: () => media.listClients({ q: q || undefined, limit: 200 }),
  });

  function openCreate() {
    setEditing(null);
    setDialogOpen(true);
  }
  function openEdit(c: AgencyClientOut) {
    setEditing(c);
    setDialogOpen(true);
  }

  return (
    <>
      <div className="flex items-center gap-2 mb-4">
        <div className="relative flex-1 max-w-md">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-400" />
          <Input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar cliente por nombre..."
            className="pl-9"
          />
        </div>
        <div className="text-xs text-ink-500 ml-auto">
          {(data ?? []).length} clientes
        </div>
        <Button onClick={openCreate}>
          <Plus size={14} /> Nuevo cliente
        </Button>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-48" />)}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {(data ?? []).map(c => <ClientCard key={c.id} client={c} onEdit={openEdit} />)}
          {!(data ?? []).length && (
            <div className="col-span-full text-center py-12 text-ink-500 border-2 border-dashed border-ink-200 rounded-lg">
              No hay clientes. Crea el primero con "Nuevo cliente".
            </div>
          )}
        </div>
      )}

      <ClientFormDialog open={dialogOpen} onOpenChange={setDialogOpen} client={editing} />
    </>
  );
}
